import { FulfillmentTile } from '@libs/shared-ui';

import { useBopisDeliveryTile } from '../../model';

export const BopisDeliveryTile = () => {
    const { isLoading, isDisabled, status, selectedDeliveryMethod, register } = useBopisDeliveryTile();

    return (
        <FulfillmentTile
            value="bopis"
            title="Pick up in store"
            iconName="store-outline"
            status={status}
            statusTestId="bopis-tile-status-message"
            isSelected={selectedDeliveryMethod === 'bopis' && !isLoading && !isDisabled}
            isDisabled={isDisabled}
            isLoading={isLoading}
            inputProps={register}
        />
    );
};
